import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlugCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { useOnline } from "../../hooks/useOnline";
import { isDesktopLocalProfile } from "../../utils/desktopProfile";
import styles from "./offlineBanner.module.scss";

// A persistent (non-dismissible) status row, the same "second header row"
// shape as LanguagePromptBanner - on mobile there's no room for an inline
// icon in the main row, so this renders below it instead, at every width.
function OfflineBanner() {
    const { t } = useTranslation();
    const online = useOnline();

    // Offline desktop build: always say where the data lives, whether or not Wi-Fi happens to be on.
    if (isDesktopLocalProfile) {
        return (
            <aside className={styles.banner} role="status">
                <FontAwesomeIcon icon={faPlugCircleXmark} className={styles.icon} aria-hidden="true" />
                <span className={styles.text}>{t("desktopLocalProfile.banner")}</span>
            </aside>
        );
    }

    if (online) return null;

    return (
        <aside className={styles.banner} role="status">
            <FontAwesomeIcon icon={faPlugCircleXmark} className={styles.icon} aria-hidden="true" />
            <span className={styles.text}>{t("offlineBanner.message")}</span>
        </aside>
    );
}

export default OfflineBanner;
